import { TAB_NAME } from '@/components/DataGenerationHistory/constants';
import { downloadHistoryStore } from '@/stores/downloadHistoryStore';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Divider, IconButton, Typography } from '@mui/material';
import { styles } from './styles';

export const DrawerHeader = () => {
  const setOpen = downloadHistoryStore.use.setOpen();

  return (
    <Box component="header" sx={styles.drawerHeaderContainer}>
      <Box sx={styles.drawerHeaderContent}>
        <Typography variant="caption" sx={styles.drawerHeaderTitle}>
          {TAB_NAME}
        </Typography>

        <IconButton onClick={() => setOpen(false)} size="small" sx={styles.drawerHeaderCloseButton}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      <Divider sx={styles.drawerHeaderDivider} />
    </Box>
  );
};
